import React from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';

import Paragraph from '../../Paragraph';
import Heading from '../../Heading';
import Button from '../../Button';

import flowerImg from '../../../images/logo-flower-only.svg';
import emailImg from '../../../images/icon-email-white.svg';
import facebookImg from '../../../images/icon-facebook-white.svg';

// const validate = (values) => {
//   if (!document.cookie.split(';').filter((item) => item.includes('gdprpolicy=accepted')).length) {
//     document.querySelector('.js-comb-register').click();
//   }
// };

const Sorry = props => (
  <div className="sorry-section legal-page">
    <div className="justifycentre register-block legal-header">
      <Heading tag="h1" classes="header-text smaller"><span id="register2">That’s fine</span></Heading>
    </div>
    <div className="legal-content-wrap">
      <Paragraph>We understand that sharing your personal details is a significant step and something you’re not content to do currently.</Paragraph>
      <Paragraph>We do need your permission to store your personal information so we know how we can best support you. If {"you'd"} like to know more about how we securely store your data, please take a look at our <a href="/privacy/" target="_blank">privacy policy</a>. If at any stage, you change your mind and are happy to provide your personal information please come back and visit us again.</Paragraph>
      <Paragraph>If you’d like to go back to the start to learn more about how we use and safely store your information, please click below to <a href="/register" onClick={(e) => { e.preventDefault(); props.previousPage(); }}>start afresh</a>.</Paragraph>
      <Paragraph classes="flex-row button-groups">
        <Button classes={['color-button']} label="Start afresh" onClick={props.previousPage} />
      </Paragraph>
    </div>

    <div className="register-block external-block">
      <div className="flex-row four-cols small-spacing">
        <div className="col">
          <div className="external-item aspect-ratio-image flower">
            <a className="external-item-inner" href="/about-livewell/">
              <img src={flowerImg} alt="livewell dorset logo" />
              <Heading tag="h3" classes="header-text">Learn more About us</Heading>
            </a>
          </div>
        </div>
        <div className="col">
          <div className="external-item aspect-ratio-image purple">
            <a className="external-item-inner" href="/about-livewell/subscribe/">
              <img src={emailImg} alt="livewell dorset logo" />
              <Heading tag="h3" classes="header-text">Subscribe to our monthly news and stories email</Heading>
            </a>
          </div>
        </div>
        <div className="col">
          <div className="external-item aspect-ratio-image green">
            <a className="external-item-inner" href="https://www.facebook.com/groups/ourlivewell" target="_blank">
              <img src={facebookImg} alt="livewell dorset logo" />
              <Heading tag="h3" classes="header-text">Join Our LiveWell Facebook Group</Heading>
            </a>
          </div>
        </div>
        <div className="col">
          <div className="external-item aspect-ratio-image story">
            <a className="external-item-inner" href="/success-stories">
              <Heading tag="h3" classes="header-text">Read stories about how we have helped people</Heading>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
);

Sorry.propTypes = {
  previousPage: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'registration', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(Sorry);



// WEBPACK FOOTER //
// ./src/Components/Register/FormPages/Sorry.jsx